import {erpIcon, mobileApplicationIcon, webApplicationIcon} from "../svgIcons";

const softwareServices = [
  {
    id:1,
    title: 'ERP Software',
    svgIcon: erpIcon,
    bgColor: 'bg-blue-100',
    routePath: '/services/erp-solutions',
    description: 'Streamline your entire business with a unified ERP system that integrates finance, inventory, sales, HR, and operations into one powerful platform. Gain real-time insights, eliminate manual processes, and drive smarter decisions—so you can scale with confidence.',
    translationKeys: {
      title: "erpSoftware",
      description: "erpDescription"
    }
  },
  {
    id:2,
    title: 'Web Development',
    svgIcon: webApplicationIcon,
    bgColor: 'bg-pink-100',
    routePath: '/services/web-application-development',
    description: 'Create intuitive, high-performance mobile apps that keep your users connected on the go. Whether for iOS, Android, or cross-platform, we design and develop mobile solutions that deliver seamless experiences and real-world impact.',
    translationKeys: {
      title: "webDevelopment",
      description: "webDevelopmentDescription"
    }
  },
  {
    id:3,
    title: 'Mobile Apps',
    svgIcon: mobileApplicationIcon,
    bgColor: 'bg-green-100',
    routePath: '/services/mobile-development',
    description: 'Launch fast, user-friendly mobile apps that keep your customers connected—anytime, anywhere.',
    translationKeys: {
      title: "mobileApp",
      description: "mobileAppDescription"
    }
  },
]

const points = [
  "benefit1",
  "benefit2",
  "benefit3",
  "benefit4"
];

const expertiseItems = [
  {
    svg: (
      <svg className="w-16 h-16 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 6V3m0 18v-3m9-6h-3M6 12H3m15.364-6.364l-2.121 2.121M8.757 15.243l-2.121 2.121m0-10.606l2.121 2.121M15.243 15.243l2.121 2.121" />
      </svg>
    ),
    title: "Innovation Design",
    description: "We embed innovation into every layer of development—enabling you to stay ahead of evolving digital trends.",
    translationKeys: {
      title: "innovationDesign",
      description: "innovationDescription"
    }
  },
  {
    svg: (
      <svg className="w-16 h-16 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.354a8 8 0 100 15.292 8 8 0 000-15.292zM12 8v4l2.5 1.5" />
      </svg>
    ),
    title: "Time-Tested Processes",
    description: "From planning to deployment, our proven methodologies ensure consistent delivery and measurable outcomes.",
    translationKeys: {
      title: "timeTestedProcesses",
      description: "timeTestedDescription"
    }
  },
  {
    svg: (
      <svg className="w-16 h-16 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M4 4h16v4H4zM4 10h16v10H4z" />
      </svg>
    ),
    title: "Seamless Integration",
    description: "We build software that integrates smoothly with your existing infrastructure, tools, and workflows.",
    translationKeys: {
      title: "seamlessIntegration",
      description: "integrationDescription"
    }
  },
  {
    svg: (
      <svg className="w-16 h-16 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 11c.658 0 1.316-.032 1.973-.097M12 3v1m0 16v1m-6.364-3.636l.707.707m12.728-12.728l.707.707M3 12h1m16 0h1M4.222 4.222l.707.707" />
      </svg>
    ),
    title: "24/7 Support Ecosystem",
    description: "Our global team ensures your systems stay up and running—with proactive monitoring and real-time support.",
    translationKeys: {
      title: "supportEco",
      description: "supportDescription"
    }
  }
];

const techStacks = [
  { name: ".NET", translateKey: "techStacks.dotnet", imgName: "dot-net.avif" },
  { name: "WooCommerce", translateKey: "techStacks.wooCommerce", imgName: "woo.avif" },
  { name: "WordPress", translateKey: "techStacks.wordpress", imgName: "wordpress.avif" },
  { name: "Laravel", translateKey: "techStacks.laravel", imgName: "laravel.avif" },
  { name: "Node.js", translateKey: "techStacks.nodejs", imgName: "node-js.avif" },
  { name: "Azure", translateKey: "techStacks.azure", imgName: "azure.avif" },
  { name: "Flutter", translateKey: "techStacks.flutter", imgName: "flutter.avif" },
  { name: "React JS", translateKey: "techStacks.react", imgName: "react-js.avif" },
  { name: "PHP", translateKey: "techStacks.php", imgName: "php.avif" },
  { name: "AWS Web Server", translateKey: "techStacks.aws", imgName: "aws.avif" },
  { name: "Java", translateKey: "techStacks.java", imgName: "java.avif" },
  { name: "Kotlin", translateKey: "techStacks.kotlin", imgName: "kotlin.avif" },
  { name: "Swift", translateKey: "techStacks.swift", imgName: "swift.avif" },
  { name: "Android", translateKey: "techStacks.android", imgName: "android.avif" },
  { name: "IOS", translateKey: "techStacks.ios", imgName: "ios.avif" },
  { name: "IOT", translateKey: "techStacks.iot", imgName: "iot.avif" },
  { name: "Python", translateKey: "techStacks.python", imgName: "python.avif" },
  { name: "MySQL", translateKey: "techStacks.mysql", imgName: "mysql.avif" },
  { name: "Mongo DB", translateKey: "techStacks.mongo", imgName: "mongo.avif" },
  { name: "Redis", translateKey: "techStacks.redis", imgName: "redis.avif" },
];

export {
  softwareServices,
  points,
  expertiseItems,
  techStacks
}
